
const calcularEdad = (fecha) => {

    if (!fecha) return false

    var fecha_aux = fecha.split("-")
    fecha = fecha_aux[1] +"/"+ fecha_aux[2] +"/"+ fecha_aux[0]

    var hoy = new Date();
    var cumpleanos = new Date(fecha);
    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
    var m = hoy.getMonth() - cumpleanos.getMonth();

    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
    }

    return edad;
}

export default calcularEdad
